import React from "react";
export const TotalRequestIcon = () => {
  return (
      <svg
          viewBox="0 0 24 24"
          fill="none"
          strokeWidth="2"
          stroke="#123262"
      >
        <path d="M3 3v18h18"  />
        <path d="m19 9-5 5-4-4-3 3" />
      </svg>
  );
};
